/**
 * A/B Test: Landing page variant assignment
 * 50% of unauthenticated visitors see /showcase, 50% see /onboarding
 * Each visit is independently randomized (no caching).
 */

const AB_VARIANT_KEY = "gitfit_ab_landing_variant";

export type LandingVariant = "showcase" | "onboarding";

/**
 * Get a random landing page variant for the current visitor.
 * Truly random 50/50 on every visit — no localStorage caching.
 * The assigned variant is stored so getStoredLandingVariant() can
 * read it later in the same session (e.g. for signup attribution).
 */
export function getLandingVariant(): LandingVariant {
  const variant: LandingVariant = Math.random() < 0.5 ? "showcase" : "onboarding";
  try {
    localStorage.setItem(AB_VARIANT_KEY, variant);
  } catch {
    // localStorage unavailable — variant still returned
  }
  return variant;
}

/**
 * Read the variant assigned during this session.
 * Returns null if no variant has been assigned yet.
 */
export function getStoredLandingVariant(): LandingVariant | null {
  try {
    const stored = localStorage.getItem(AB_VARIANT_KEY);
    if (stored === "showcase" || stored === "onboarding") {
      return stored;
    }
    return null;
  } catch {
    return null;
  }
}
